export default {
  clubClasses: [],
  clubClasses_: [],
  clubModules: [],
  eventLabels: [],
  clubLocations: [],
  classTimesByLocationTimes : [{
      id: 1,
      title: 'My Event',
      startDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 3),
      endDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 2),
      url: '',
      classes: 'event-success',
      label: 'business'
    }]
}
